/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".happ-workspace-tab[_ngcontent-%COMP%]{cursor:pointer;border:1px solid #d8d8d8;-webkit-transform:translate(0,-2px);background:#fafafa;margin:8px}.happ-workspace-tab[_ngcontent-%COMP%]:hover{box-shadow:0 2px 10px #e9e9e9;transform:translate(0,-2px)}.mat-checkbox-layout[_ngcontent-%COMP%]{white-space:normal!important}"];
export { styles as styles };
